<template>
  <div>
    <v-toolbar dark flat class="secondary headline mb-0">
      <v-toolbar-title>{{editUser && !editUser.profile ? 'Edit User' : editUser && editUser.profile ? 'Profile' : 'Create New User'}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!profile" class="ml-4" dark flat icon @click="closeDialog"><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-container style="background-color:white">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-alert :value="error !== null ? true : false" color="error" icon="new_releases">{{ error }}</v-alert>
        <v-flex mb-3 xs12><v-alert :value="progressUpload === 100" class="title" color="success"><v-icon dark class="mr-2">lock</v-icon>Image Upload Successful (Dont Forget To Save)</v-alert></v-flex>
        <v-flex mb-3 xs12><v-alert :value="emailSent" class="title" color="success"><v-icon dark class="mr-2">lock</v-icon>Email Successfully Sent</v-alert></v-flex>
        <v-flex mb-3 xs12><v-alert :value="emailError" class="title" color="error"><v-icon dark class="mr-2">lock</v-icon>There was an error sending the password reset. Try again.</v-alert></v-flex>
        <!-- User Avatar -->
          <v-layout mt-3 row wrap>
            <v-flex xs4 class="text-xs-center">
              <croppa :quality="1" :placeholder-font-size="8" @new-image-drawn="onNewImage" @file-choose="handleCroppaFileChoose" @zoom="onZoom" v-model="croppa" :initial-image="editUser ? editUser.avatar : null" @image-remove="removeImage" :zoom-speed="5" :width="80" :height="80"></croppa>
              <input v-if="imageSet" type="range" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal"><br>
              <v-btn @click="upload" v-if="imageSet" class="primary">UPLOAD</v-btn>
              <v-progress-linear v-if="progressUpload > 0 && progressUpload < 100" v-model="valueDeterminate"></v-progress-linear>
            </v-flex>
            <v-flex xs8 pl-3>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field v-model="createUser.first_name" :rules="nameRules" label="First Name" required prepend-icon="person"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="createUser.last_name" :rules="nameRules" label="Last Name" required prepend-icon="person"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :disabled="(editUser) && user.email !== createUser.email && !profile" clearable v-model="createUser.email" :rules="emailRules" label="Email" required prepend-icon="email"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-flex v-if="!editUser" sm12 xs12> <v-text-field v-model="createUser.password" :rules="nameRules" :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="() => (showPassword = !showPassword)" :type="showPassword ? 'text' : 'password'" name="password" label="Password" hint="At least 6 characters" min="6" counter prepend-icon="lock" required></v-text-field></v-flex>
                  <v-flex v-if="editUser" sm12 xs12> <v-btn @click="sendPasswordEmail(createUser.email)" class="primary"><v-icon left>lock</v-icon>Reset Password</v-btn></v-flex>
                </v-flex>
                <v-flex xs6>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        <v-layout mt-3 row wrap>
          <v-flex xs6><v-text-field v-model="createUser.phone_1" label="Phone Number" mask="phone" prepend-icon="phone"></v-text-field></v-flex>
          <v-flex pl-3 xs5><v-select v-model="createUser.phone_1_type" :items="phoneOptions" label="Type"></v-select></v-flex>
          <v-flex xs1><v-btn fab small color="primary" @click="Phone2 = !Phone2"><v-icon>{{ Phone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn></v-flex>
          <v-flex xs6 v-if="Phone2"><v-text-field v-model="createUser.phone_2" label="Phone Number" mask="phone" prepend-icon="phone"></v-text-field></v-flex>
          <v-flex xs5 pl-3 v-if="Phone2"><v-select pl-3 v-model="createUser.phone_2_type" :items="phoneOptions" label="Type"></v-select></v-flex>
          <v-flex xs1 v-if="Phone2"><v-btn fab small color="primary" @click="Phone3 = !Phone3"><v-icon>{{ Phone3 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn></v-flex>
          <v-flex xs6 v-if="Phone3"><v-text-field v-model="createUser.phone_2" label="Phone Number" mask="phone" prepend-icon="phone"></v-text-field></v-flex>
          <v-flex xs5 v-if="Phone3"><v-select v-model="createUser.phone_2_type" :items="phoneOptions" label="Type"></v-select></v-flex>
        </v-layout>
        <v-layout row wrap>
        <v-flex xs6><v-select prepend-icon="people" v-model="createUser.role" :items="userRole" :rules="[v => !!v || 'Item is required']" label="User Role" required></v-select></v-flex>
        <!-- <v-flex xs6 pl-3><v-text-field v-model="createUser.position" label="Position"></v-text-field></v-flex> -->
        <v-checkbox class="pl-3" label="Sales Rep?" v-model="createUser.if_sales_rep"></v-checkbox>
        </v-layout>
        <v-btn class="primary" :disabled="!valid" @click="submitUser">{{editUser ? 'Save Changes' : 'Create User'}}</v-btn>
        <v-btn v-if="!editUser || editUser && !editUser.profile" class="secondary" @click="closeDialog">Cancel</v-btn>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { auth, storage } from '../../../firebaseInit'
import 'vue-croppa/dist/vue-croppa.css'

export default {
  props: ['editUser', 'profile'],
  data () {
    return {
      fileUpload: null,
      imageSet: null,
      croppa: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      progressUpload: 0,
      uploadTask: '',
      emailSent: false,
      emailError: false,
      previousState: null,
      state: 'new',
      valid: true,
      createUser: { first_name: null, last_name: null, email: null, password: null, phone_1: null, phone_1_type: null, phone_2: null, phone_2_type: null, phone_3: null, phone_3_type: null, role: 'User', position: null, avatar: null, if_sales_rep: false },
      phoneOptions: ['Cell', 'Home', 'Office', 'Other'],
      getUsers: [],
      nameRules: [
        v => !!v || 'Field is required'
      ],
      email: null,
      showPassword: false,
      Phone2: null,
      Phone3: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  mounted () {
    if (this.editUser) {
      this.previousState = Object.assign({}, this.editUser)
      this.createUser = Object.assign({}, this.editUser)
    }
    console.log('Mounted Profile', this.profile)
  },
  computed: {
    userRole () {
      return this.$store.getters.rolesDropDown
    },
    inactiveUsers () {
      return this.$store.getters.inactiveUsers
    },
    activeUsers () {
      return this.$store.getters.userList
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    }
  },
  methods: {
    removeImage () {
      this.createUser.avatar = null
    },
    handleCroppaFileChoose (data) {
      this.imageSet = true
      this.prepFile = Object.assign({}, data)
    },
    upload () {
      if (!this.croppa.hasImage()) {
        alert('No Image Selected...')
        return
      }
      this.croppa.generateBlob((blob) => {
        var storageRef = storage.ref()
        this.uploadTask = storageRef.child('admin/userAvatars/' + this.createUser.id).put(blob)
      })
    },
    onZoom () {
      this.sliderVal = this.croppa.scaleRatio
    },
    onNewImage () {
      this.sliderVal = this.croppa.scaleRatio
      this.sliderMin = this.croppa.scaleRatio / 2
      this.sliderMax = this.croppa.scaleRatio * 2
    },
    onSliderChange (evt) {
      const increment = evt.target.value
      this.croppa.scaleRatio = +increment
    },
    sendPasswordEmail (email) {
      auth.sendPasswordResetEmail(email).then(() => {
        this.emailSent = true
      }).catch(error => {
        this.emailError = true
        console.log('There was an error sending the email: ', error)
      })
    },
    closeDialog () {
      this.emailSent = true
      this.$emit('closeDialog')
    },
    enableDeletedAccount (payload) {
      this.$emit('closeDialog')
      this.$store.dispatch('activateUser', payload)
      this.$emit('refreshContacts')
    },
    submitUser () {
      if (this.$refs.form.validate()) {
        if (!this.editUser) {
          const activeExists = this.activeUsers.filter(f => f.email === this.createUser.email)
          const inactiveExists = this.inactiveUsers.filter(f => f.email === this.createUser.email)
          if (activeExists.length > 0) {
            alert('This email address already exists. Cannot create new user with this email')
            return
          }
          if (inactiveExists.length > 0) {
            if (confirm('This email address exists with a delete account. Would you like to re-enable the deleted account?')) {
              this.enableDeletedAccount(inactiveExists[0])
            }
            return
          }
          this.$store.dispatch('createUser', this.createUser)
          this.closeDialog()
        }
        if (this.editUser) {
          const payload = {newState: this.createUser, previousState: this.previousState}
          this.$store.dispatch('editUser', payload)
          this.closeDialog()
        }
      }
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        let avatarURL = storage.ref('admin/userAvatars/' + this.createUser.id)
        avatarURL.getDownloadURL().then(downloadURL => {
          this.$emit('url', downloadURL)
          this.createUser.avatar = downloadURL
        })
      })
    }
  }
}
</script>

<style scoped>
.croppa-container {
  border-radius: 50%;
  background-color: lightblue;
  border: 2px solid grey;
}
.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}
.btn--floating.btn--small .icon {
  font-size: 30px;
}
.btn--floating.btn--small {
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/users/CreateUser.vue